import { FastlyImage } from '@components/common/image'
import { LOGO_THEME } from '@lib/constants/common'
import { Trans } from '@lingui/macro'

const MissionFold = () => (
  <div className="mt-10">
    <div className="flex items-center">
      <FastlyImage
        src={`/images/logos/logos-${LOGO_THEME}/logo.svg`}
        height={30}
        width={30}
        alt="codingal White icon"
      />
      <span className="text-xl font-600 ml-2">
        <Trans>Codingal mission</Trans>
      </span>
    </div>
    <p className="mt-3">
      <Trans>
        Codingal is on a mission to inspire school kids and teens to fall in
        love with AI & coding. Learning to code develops creativity, logical
        thinking, and problem-solving skills, preparing kids for the future. In
        today&rsquo;s world, AI is transforming industries and is an essential
        skill for the future. Over 70% of STEM-related jobs require coding and
        AI expertise, and students who start learning early will become the
        leaders, creators, and entrepreneurs shaping tomorrow&rsquo;s world.
      </Trans>
    </p>
  </div>
)

export default MissionFold
